import React, { Component } from "react";
import glamorous from "glamorous";
import SearchSection from "../../blocks/SearchSection";
import TripCard from "../../common/TripCard";
import LoadMore from "../../common/LoadMore";

const Grid = glamorous.div({
  display: "grid",
  gridTemplateColumns: "repeat(3,319px)",
  gridGap: "26px 34px",
  justifyContent: "center",
  paddingTop: 51,
  "@media (max-width: 1105px)": {
    gridTemplateColumns: "repeat(1,319px)"
  }
});

const Gradient = glamorous.div({
  "@media (max-width: 570px)": {
    height: 258,
    background:
      "linear-gradient(to bottom, rgba(0,0,0,0) 0%, #181221 57.25%, #181221 100%)",
    position: "absolute",
    width: "100%",
    bottom: 0
  }
});

const LoadMoreContainer = glamorous.div({
  "@media (max-width: 570px)": {
    zIndex: 2,
    position: "absolute",
    width: "100%",
    bottom: 0
  }
});

const renderCards = (trips, joinTrip) => {
  if (trips) {
    return trips.slice(0, 3).map((trip, index) => {
      return (
        <TripCard key={trip.id} trip={trip} joinTrip={joinTrip} index={index} />
      );
    });
  }
};

class UpcomingTrips extends Component {
  render() {
    const { trips, joinTrip, dropInSearchResults } = this.props;

    return (
      <SearchSection
        title="Upcoming Trips"
        backgroundColor="rgba(0,0,0,0.3)"
        gradient="radial-gradient(circle, #230F36 0%, rgba(35,15,54,0) 100%), radial-gradient(circle, #000000 0%, rgba(0,0,0,0.3) 0%)"
      >
        <Grid>{renderCards(trips, joinTrip)}</Grid>
        <LoadMoreContainer>
          <LoadMore
            dropInSearchResults={dropInSearchResults}
            searchUsers={false}
            filters={{}}
          />
        </LoadMoreContainer>
        <Gradient />
      </SearchSection>
    );
  }
}

export default UpcomingTrips;



// WEBPACK FOOTER //
// ./src/components/pages/Search/UpcomingTrips.jsx